import { useState } from "react";
import { X } from "lucide-react";
import { Input } from "./ui/input";

export const SkillsInput = ({ skills, onChange }) => {
  const [val, setVal] = useState("");
  const add = () => {
    const v = val.trim();
    if (v && !skills.includes(v) && skills.length < 60) onChange([...skills, v]);
    setVal("");
  };
  return (
    <div className="space-y-4">
      <Input value={val} maxLength={200} onChange={(e) => setVal(e.target.value)} data-testid="skills-input" placeholder="Type a skill and press Enter"
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(); } }}
        className="bg-[#0c0e14] border-white/10 focus-visible:ring-emerald-500" />
      <div className="flex flex-wrap gap-2">
        {skills.map((s) => (
          <span key={s} className="flex items-center gap-1.5 rounded-full bg-emerald-500/10 text-emerald-300 text-sm px-3 py-1" data-testid={`skill-chip-${s}`}>
            {s}
            <button onClick={() => onChange(skills.filter((x) => x !== s))} aria-label={`Remove ${s}`} className="hover:text-white"><X className="h-3 w-3" /></button>
          </span>
        ))}
      </div>
    </div>
  );
};
